// Decoración Hokusai sutil y no intrusiva: sol ocre (Fuji Rojo), silueta del
// Monte Fuji y banda de olas seigaiha. Siempre pointer-events-none y baja opacidad.
export default function HokusaiDecor() {
  return (
    <div aria-hidden="true" data-testid="hokusai-decor" className="pointer-events-none absolute inset-0 overflow-hidden z-0">
      {/* Sol / luna ocre — evoca «Fuji Rojo» */}
      <div className="absolute -top-20 -right-16 h-72 w-72 rounded-full bg-[#C75B28] opacity-[0.07] blur-[1px]" />

      {/* Monte Fuji con cumbre nevada */}
      <svg
        className="absolute bottom-16 right-4 w-56 lg:w-72 text-primary opacity-[0.06] hidden md:block"
        viewBox="0 0 200 130" fill="currentColor"
      >
        <path d="M16 116 L100 14 L184 116 Z" />
        <path d="M74 58 L100 14 L126 58 L117 52 L109 62 L100 50 L91 62 L83 52 Z" fill="#F8F5EE" />
      </svg>

      {/* Banda de olas seigaiha al pie */}
      <div className="absolute inset-x-0 bottom-0 h-24 seigaiha-pattern opacity-50" />
    </div>
  );
}
